<template>
    <div class="user-logout-timer">

        <b-modal ref="logout-modal"
                 hide-footer
                 title="Auto Logout">
            <p>
                You will be automatically logged out in {{ countdown }} seconds.
            </p>
            <p>
                To cancel auto logout, tap the screen or move the cursor.
            </p>
        </b-modal>

    </div>
</template>

<script>
import Vue from 'vue'
import IdleVue from 'idle-vue'

/**
 * Component to automatically log the user out after a specified time interval
 */
const TIMER_DELAY = 30 * 60
const COUNTDOWN_LENGTH = 30

const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: TIMER_DELAY * 1000
})

export default Vue.extend({
    name: 'UserLogoutTimer',
    data () {
        return {
            countdown: null,
        }
    },
    onIdle () {
        if (this.$user.userId()) {
            this.$refs['logout-modal'].show()
            this.startCountdown()
        }
    },
    //TODO: investigate why this isn't getting called
    onActive () {
        this.$refs['logout-modal'].hide()
    },
    methods: {
        startCountdown () {
            this.countdown = COUNTDOWN_LENGTH
            const interval = setInterval(() => {
                this.countdown--

                // time's up
                if (this.countdown <= 0) {
                    clearInterval(interval)
                    this.$refs['logout-modal'].hide()
                    this.$user.logoutUser()
                }
            }, 1000)
        }
    },
})
</script>

